<template>
  <div>
    <h2 class="mb-5">Change Social Media</h2>
    <vue-form-generator
      :schema="schema"
      :model="model"
      :options="formOptions"
      ref="socialForm"
      id="social-form-generator"
      @keyup.enter.native="updateSocialInformation"
    ></vue-form-generator>
  </div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import schemaDefinition from '@/components/profile/sections/profile/social/schema';

import helper from '@/libs/helper';
import { DEFINE_PROFILE_SOCIAL } from '@/vuex/modules/profile/types/actions';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
  },
  data() {
    return {
      model: {},
      schema: schemaDefinition.schema(this.updateSocialInformation),
      formOptions: schemaDefinition.formOptions,
    };
  },
  methods: {
    validate() {
      return this.$refs.socialForm.validate();
    },
    setDefaultModel() {
      const profile = this.$store.getters.profile;
      if (profile && profile.social) {
        this.model = helper.copy(profile.social);
      }
    },
    updateSocialInformation() {
      this.$reqs.post(`/users/${this.$store.getters.user.id}/profile/social`, this.model)
        .then((response) => {
          this.$store.dispatch(DEFINE_PROFILE_SOCIAL, { social: response.data.social });
          this.$notify({ group: 'alert', text: 'Social data updated.' });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.setDefaultModel();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/tabs/social_media/SocialMediaContent.vue